import * as service from './signup.service.js'

export default {

  data() {
    return {
      signupError: '',
      signupsucess: '',
      passClicked: false,
      ispasswordok: false,
      isdisablebutton: true,
      signupForm: {
        useremail: '',
        organisation: '',
        userpassword: '',
        confirmpassword: ''
      },
      rules: {
        organisation: [{
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 40,
            message: 'Length should be 1 to 40'
          }

        ],
        useremail: [{
            required: true,
            message: 'This field is required',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Invalid Email Address'
          },



        ],
        userpassword: [{
            required: true,
            message: 'This field is required'
          },
          {
            max: 40,
            message: 'Length should be 8 to 40'
          }

        ],
        confirmpassword: [{
            required: true,
            message: 'This field is required'
          },
          {
            max: 40,
            message: 'Length should be 8 to 40'
          }
        ]




      }

    }
  },

  mounted() {

  },

  methods: {
    submitForm(formName) {

      this.signupError = ''
      let context = this
      this.$refs[formName].validate((valid) => {

        if (valid) {
          loader.startLoader()
          var model = {
            OrganizationName: this.signupForm.organisation,
            Email: this.signupForm.useremail,
            NewPassword: this.signupForm.userpassword,
            ConfirmPassword: this.signupForm.confirmpassword
          };

          service.signup(model).then(function (response) {
            if (response == "") {
              loader.stopLoader()

              $('.alert').show()
              context.login()
            }


          }).catch((error) => {;
            var message = error.responseText;
            var parsed = JSON.parse(message);
            this.signupError = parsed.Message;
            loader.stopLoader()
            $('.alert').show()
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'SIGNUP - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },
    login() {
      let contextdata = this;
      let loginData = 'grant_type=password&username=' + this.signupForm.useremail + '&password=' + this.signupForm.userpassword

      service.userLogin(loginData).then(function (response) {

        loader.stopLoader()
        $('.alert').show()

        localStorage.setItem('authentication', JSON.stringify(response))

        var auth = JSON.parse(localStorage.getItem('authentication'))

        if (auth) {
          if (auth.access_token) {
            if (auth.FirstName) {

              window.userName = auth.FirstName + ' ' + auth.LastName
            }
            if (auth.role == "OrganizationAdmin") {
              if (!auth.FirstName) {

                contextdata.$router.push('/signupconfirm?OrganizationName=' + contextdata.signupForm.organisation)
              } else {
                contextdata.$router.push('AdminDashboard')
              }

            } else {
              contextdata.$router.push('AdminDashboard')
            }
            // if(auth.IsFirstLogin=="True"){

            //   contextdata.$router.push('/signupconfirm?OrganizationName='+contextdata.signupForm.organisation)
            // }
            //   else{
            //     contextdata.$router.push('AdminDashboard')
            //   }


          } else {

            router.push('login')
          }

        }

      }).catch((error) => {
        loader.stopLoader()
        $('.alert').show()
        var message = error.responseText;
        var parsed = JSON.parse(message);
        this.signusignupConfirmErrorpError = parsed.Message;

      })
    },
    signin() {
      let context = this
      context.$router.push('/login')
    },
    togglePassword() {
      if (!this.passClicked) {
        $('#password').children().attr('type', 'text')
        this.passClicked = true
      } else {
        $('#password').children().attr('type', 'password')
        this.passClicked = false
      }
    },
    togglePasswordConfirm() {;
      if (!this.passClickedConfirm) {
        $('#passwordconfirm').children().attr('type', 'text')
        this.passClickedConfirm = true
      } else {
        $('#passwordconfirm').children().attr('type', 'password')
        this.passClickedConfirm = false
      }

    },

    alertClose() {
      $('.alert').hide()
    }
  },
  watch: {

    signupForm: {
      handler: function (newValue) {

        if (newValue.userpassword.length >= 8 && newValue.userpassword.match(/[!@#$%^&*(){}[\]<>?/|.:;_-]/) && newValue.userpassword.match(/^(?=.*[A-Z])/) && newValue.userpassword == newValue.confirmpassword) {

          this.isdisablebutton = false;
        } else {
          this.isdisablebutton = true;
        }


        if (newValue.userpassword.length >= 8 && newValue.userpassword.match(/[!@#$%^&*(){}[\]<>?/|.:;_-]/)) {

          this.ispasswordok = false;
        } else {
          this.ispasswordok = true;
        }


      },
      deep: true
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.controller.js